import { Box, Header, Loader, Table } from '@profitowi/component-library';
import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { SortingRule } from 'react-table';

import ErrorMessages from 'components/ErrorMessages/ErrorMessages';
import { SETTLEMENT } from 'constants/queries/settlement';
import { usePagination } from 'hooks/usePagination';
import { getSettlementContracts } from 'services/settlement';
import { Page } from 'types/request';
import { Contract } from 'types/settlement';
import { decodeUriSortParams } from 'utils/table';

import useSettlement from '../../../useSettlement';
import { columns } from './columns';

const ContractsStage = () => {
  const { settlementId = NaN } = useSettlement();
  const pagination = usePagination(10);
  const { currentPage, perPage } = pagination;
  const [sortBy, setSortBy] = useState<Array<SortingRule<any>>>([]);
  const handleSortBy = useCallback((sortBy: SortingRule<any>[]) => setSortBy(sortBy), []);

  const { data, error, isError, isLoading, isSuccess, isFetching } = useQuery<
    Page<Contract>,
    AxiosError
  >(
    [SETTLEMENT.SETTLEMENT_CONTRACTS, settlementId, currentPage, perPage, sortBy],
    () => getSettlementContracts(settlementId, currentPage, perPage, decodeUriSortParams(sortBy)),
    { keepPreviousData: true }
  );

  return (
    <Box className="space-y-6">
      <Header as="h4" size="lg" weight="semibold">
        Kontrakty
      </Header>

      {isError && <ErrorMessages error={error} />}
      {isLoading && <Loader className="h-12 w-12" />}
      {isSuccess && data && (
        <Box.FullWidth>
          <Table
            columns={columns}
            totalPages={data.totalPages}
            data={data.content}
            pagination={pagination}
            isLoading={isFetching}
            sortBy={sortBy}
            onSortBy={handleSortBy}
          />
        </Box.FullWidth>
      )}
    </Box>
  );
};

export default ContractsStage;
